import { useReducer, createContext } from 'react';
import { minCensusZoom, mapStaticVariables } from '../model/StaticVariables';

const MapContext = new createContext();
export default MapContext;

const map_init = {
    map: null,
    census_geometry: [],
    svi: [],
    county_geometry: [],
    hhs_geometry: [],
    detail_level: 'low', //low or high
    fips: null,
    fipsList: { features: [], stateNames: [], countyFips: [], stateFips: [] },
    referenceAdded: 0,
    census_loaded: 1,
    county_loaded: 0,
    init_load: 0,
    boundingBox: mapStaticVariables.extents.contiguous_us_and_pr,
    tiles: {},
    zoom: 4,
    zoomRead: 4,
    wait: false
};
export { map_init };
const mapActions = (state, dispatch) => {
    return {
        setHHS: () => dispatch({ type: 'setHHS', value: !state.hhs }),
        setTiles: (value) => dispatch({ type: 'setTiles', value }),
        setFipsList: (value) => dispatch({ type: 'setFipsList', value }),
        setFips: (value) => dispatch({ type: 'setFips', value }),
        setSvi: (value) => dispatch({ type: 'setSvi', value }),
        setCountyGeo: (value) => dispatch({ type: 'setCountyGeo', value }),
        setCensusGeo: (value) => dispatch({ type: 'setCensusGeo', value }),
        setReferenceAdded: () => dispatch({ type: 'setReferenceAdded' }),
        setCensusLoadStatus: (value) => dispatch({ type: 'setCensusLoadStatus', value }),
        setCountyLoadStatus: (value) => dispatch({ type: 'setCountyLoadStatus', value }),
        setInitLoad: () => dispatch({ type: 'setInitLoad' }),
        setMap: (value) => dispatch({ type: 'setMap', value }),
        doMapReset: () => dispatch({ type: 'doMapReset' }),
        setZoom: (value) => dispatch({ type: 'setZoom', value }),
        setZoomRead: (value) => dispatch({ type: 'setZoomRead', value }),
        setWait: (value) => dispatch({ type: 'setWait', value }),
        setCenter: (value) => dispatch({ type: 'setCenter', value }),
        setBbox: (value) => dispatch({ type: 'setBbox', value })
    };
};

function mapReducer(state, action) {
    switch (action.type) {
        case 'setInitLoad':
            return { ...state, init_load: 1 };
        case 'setCensusGeo':
            return { ...state, census_geometry: action.value };
        case 'setCountyGeo':
            return { ...state, county_geometry: action.value };
        case 'setSvi':
            return { ...state, svi: action.value };
        case 'setReferenceAdded':
            return { ...state, referenceAdded: true };
        case 'setCensusLoadStatus':
            return { ...state, census_loaded: action.value };
        case 'setCountyLoadStatus':
            return { ...state, county_loaded: action.value };
        case 'setTiles':
            return { ...state, tiles: action.value };
        case 'setFipsList':
            return { ...state, fipsList: action.value };
        case 'setFips':
            return { ...state, fips: action.value };
        case 'setMap':
            return { ...state, map: action.value };
        case 'setZoomRead':
            return { ...state, zoomRead: action.value, detail_level: action.value >= minCensusZoom ? 'high' : 'low' };
        case 'setZoom':
            return { ...state, zoom: action.value, zoomRead: action.value, detail_level: action.value >= minCensusZoom ? 'high' : 'low' };
        case 'setWait':
            return { ...state, wait: action.value };
        case 'setBbox':
            console.log('>>>bbox updated', action);
            return { ...state, boundingBox: action.value };
        default:
            return state;
    }
}

const MapProvider = ({ children, options }) => {
    const [state, dispatch] = useReducer(mapReducer, { ...map_init });
    const value = {
        ...state,
        ...options,
        ...mapActions(state, dispatch)
    };
    return <MapContext.Provider value={value}>{children}</MapContext.Provider>;
};
export { MapProvider };
